var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBankingAndPaymentsTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-4644.000000, -503.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-banking-and-payments/Transactions",
    transform: "translate(4644.000000, 503.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.104,16.9760556 C18.361,16.2308679 18.361,15.0239444 19.104,14.2797584 L20.844,12.5359792 L9.103,12.5369808 L9.103,10.6299415 L20.844,10.6299415 L19.104,8.88716392 C18.361,8.14197627 18.361,6.93505274 19.104,6.19086669 L24.488,11.5834611 L19.104,16.9760556 Z M13.535,26.2989139 C14.278,27.0430999 14.278,28.2500235 13.535,28.9952111 L8.151,23.6016151 L13.535,18.2090206 C14.278,18.9552099 14.278,20.1621334 13.535,20.9063194 L11.794,22.649097 L23.536,22.649097 L23.537,24.5551347 L11.794,24.5551347 L13.535,26.2989139 Z M25.993,2.07330433 L24,0.0771229146 L22.008,2.07330433 L20.016,0.0771229146 L18.023,2.07330433 L16.031,0.0771229146 L14.039,2.07330433 L12.046,0.0771229146 L10.054,2.07330433 L8.062,0.0771229146 L6.069,2.07330433 L4,0 L4,32 L28,32 L28,0.0631005665 L25.993,2.07330433 Z",
    id: 83
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBankingAndPaymentsTransactions);
export default __webpack_public_path__ + "static/media/home-banking-and-payments-transactions.6b5193a9.svg";
export { ForwardRef as ReactComponent };